export const AnchorListHandlerModule = (function () {
  let anchorsMenuOpened = false;
  let isAnchorsFixed = false; // By default, anchors are in normal document flow

  const anchorsMenu = document.querySelector('.anchors');
  const mobileHeadingList = document.querySelector('.mobile-anchors-list');
  const desktopHeadingList = document.querySelector('.anchors-list');
  const mobileHeadingButton = document.querySelector(
    '.button-page-content-mobile',
  );
  const headings = document.querySelectorAll(
    '.article-content h2, .article-content h3, .article-content h4 .article-content h5 .article-content h6',
  );
  const positionToggleButton = document.querySelector('.button-pin');

  const populateHeadingList = (headingList) => {
    headingList.innerHTML = '';
    if (headings.length === 0) {
      desktopHeadingList?.classList.add('hidden');
      mobileHeadingButton?.classList.add('hidden');
    }
    headings.forEach((heading) => {
      const id = heading.id;
      if (!id) return; // Skip headings without an id
      const listItem = document.createElement('li');
      listItem.classList.add('anchors-list-item');
      const anchor = document.createElement('a');
      anchor.href = `#${id}`;
      anchor.classList.add(heading.localName);
      anchor.innerText = heading.innerText;
      anchor.classList.add('anchors-list-link');

      listItem.appendChild(anchor);
      headingList.appendChild(listItem);
    });

    if (headingList === mobileHeadingList) {
      headingList.querySelectorAll('a').forEach((anchor) => {
        anchor.addEventListener('click', () => {
          mobileHeadingList.classList.remove('opened');
        });
      });
    }
  };

  const toggleAnchorsMenu = () => {
    if (anchorsMenuOpened) {
      anchorsMenu.classList.remove('opened');
      anchorsMenu.classList.add('closed');
      anchorsMenuOpened = false;
    } else {
      anchorsMenu.classList.add('opened');
      anchorsMenu.classList.remove('closed');
      anchorsMenuOpened = true;
    }
  };

  const initToggleAnchorsMenu = () => {
    if (!anchorsMenu) return;
    const isAnchorsMenuClosed =
      localStorage.getItem('isAnchorsMenuClosed') === 'true';

    anchorsMenu.classList.remove('opened', 'closed');

    anchorsMenu.classList.add(isAnchorsMenuClosed ? 'closed' : 'opened');
    anchorsMenuOpened = !isAnchorsMenuClosed;

    const toggleButton = anchorsMenu.querySelector('.button-toggle');
    if (!toggleButton) return;

    toggleButton.addEventListener('click', (event) => {
      event.preventDefault();
      toggleAnchorsMenu();
      localStorage.setItem(
        'isAnchorsMenuClosed',
        anchorsMenu.classList.contains('closed'),
      );
    });
  };

  const initPositionToggle = () => {
    if (!positionToggleButton || !anchorsMenu) return;

    isAnchorsFixed = localStorage.getItem('anchorsFixed') === 'true';

    updatePositionState();

    positionToggleButton.addEventListener('click', (event) => {
      event.preventDefault();
      isAnchorsFixed = !isAnchorsFixed;
      updatePositionState();
      localStorage.setItem('anchorsFixed', isAnchorsFixed);
    });
  };

  const updatePositionState = () => {
    if (isAnchorsFixed) {
      anchorsMenu.classList.add('fixed-position');
      positionToggleButton.classList.add('active');
    } else {
      anchorsMenu.classList.remove('fixed-position');
      positionToggleButton.classList.remove('active');
    }
  };

  const updateHeadingLists = () => {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 992 && desktopHeadingList) {
      populateHeadingList(desktopHeadingList);
    } else if (mobileHeadingList) {
      populateHeadingList(mobileHeadingList);
    }
  };

  const init = () => {
    initToggleAnchorsMenu();
    initPositionToggle();
    updateHeadingLists();
    window.addEventListener('resize', updateHeadingLists);
  };

  return {
    init,
  };
})();

export const AnchorScrollHandlerModule = (function () {
  const scrollToTopButton = document.querySelector('.anchors-scroll-top');

  const scrollToTop = (event) => {
    event.preventDefault();

    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  };

  const initializeEventListeners = () => {
    if (scrollToTopButton) {
      scrollToTopButton.addEventListener('click', scrollToTop);
    }
  };

  const init = () => {
    initializeEventListeners();
  };

  return {
    init,
  };
})();
